import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent, ref } from "vue";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { useI18n } from "vue-i18n";
import { getGroupExploToken } from "@/api/gql/group";
import closeIcon from "@/assets/images/svg/close.svg";
import ModalModule from "@/store/modules/modal";
import POSConfigModule from "@/store/modules/pos-config";
import UserModule from "@/store/modules/user";
import NotificationService from "@/services/notification.service";
import { exploTranslations } from "@/constants/dashboards";
import i18n from "@/lang";
export default defineComponent({
  name: ModalComponents.Analytics,
  setup: function setup() {
    var closeIconStyle = "width: 30px; height: 30px; filter: contrast(170%) invert(100%);";
    var closeIconContent = closeIcon;
    var closeIconAlt = "Close";
    var modalVisible = dialogVisibleForStatus(ModalStatus.CashierReports);

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var isLoading = ref(true);
    var dashboardId = "L9Ymn7qxXl";
    var dashboardToken = ref("");
    var sellerId = UserModule.userId;

    function getCustomeToken() {
      return "".concat(dashboardId, ":").concat(dashboardToken.value);
    }

    function generateVariablesObject() {
      if (Object.keys(exploTranslations).includes(dashboardId)) {
        return pullTranslations(exploTranslations[dashboardId]);
      }

      return {};
    }

    function pullTranslations(translations) {
      var translationsEntries = Object.entries(translations).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return [key, String(i18n.global.t(value))];
      });
      return Object.fromEntries(translationsEntries);
    }

    return {
      modalVisible: modalVisible,
      closeIconStyle: closeIconStyle,
      closeIconContent: closeIconContent,
      closeIconAlt: closeIconAlt,
      isLoading: isLoading,
      t: t,
      dashboardToken: dashboardToken,
      getGroupExploToken: getGroupExploToken,
      getCustomeToken: getCustomeToken,
      sellerId: sellerId,
      generateVariablesObject: generateVariablesObject
    };
  },
  methods: {
    close: function close() {
      ModalModule.setStatus(ModalStatus.Hidden);
    },
    loadExploScript: function loadExploScript() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  if (document.getElementById("explo-script")) {
                    resolve();
                    return;
                  }

                  var script = document.createElement("script");
                  script.id = "explo-script";
                  script.src = "https://embed.explo.co/bundle.js";

                  script.onload = function () {
                    return resolve();
                  };

                  script.onerror = function () {
                    return reject(new Error("Failed to load the Explo script"));
                  };

                  document.head.appendChild(script);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var groupId, token;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this.loadExploScript();

            case 3:
              // fetch the dashboard token
              groupId = POSConfigModule.groupId || UserModule.getUserGroupId;
              _context2.next = 6;
              return _this.getGroupExploToken(groupId);

            case 6:
              token = _context2.sent;
              _this.dashboardToken = token;
              _this.isLoading = false;
              _context2.next = 16;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              console.error("Error loading Explo script", _context2.t0);
              NotificationService.showCustomError(_this.t("error.load-dashboard"));

              _this.close();

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 11]]);
    }))();
  }
});